import { create } from 'zustand';
import { devtools, persist } from 'zustand/middleware';

import { STORAGE_KEYS } from '@config/constants';
import {dataPolicies} from "@/core/api/sigma"

//import { SweetAlert2 } from 'sweetalert2-react-content';

// Estado inicial del user. Se exporta para poder reiniciarlo desde useAuth
// y desde páginas terminales (error pages) sin arrastrar datos de sesiones anteriores.
const initialUser = {
  cpais: '',
  nlocaliza: '',
  ccita: '',
  ccedasegurado: '',
  detailLocalizador: {
    cciaseg: '',
    ccliente: '',
    cplan: '',
    fcontacto: '',
    tlocaliza: '',
    cdoctor: '',
    cclinica: '',
    itclave: '',
    itipodoctit: '',
    ccedtitu: '',
    xtitular: '',
    xtitular_ap: '',
    fnacimiento: '',
  },
  profile: {},
  results: {},
  nlocalizaCreated: '',
  ccitaCreated: '',
  detailLocalizadorCreated: {},
  detailsRequest: {
    ccedasegurado: '',
    ccedtitular: '',
    cciaseg: '',
    ccliente: '',
    cplan: '',
    cproducto: '',
    cprocedencia: '',
    xcelular: '',
    xemail: '',
  },
  coverage: null as dataPolicies | null,
};

//import type { User, UserPermissions } from '@shared/types/common.types';
//import type { AuthState } from './types';


/**
 * Store de autenticación
 * Maneja estado de usuario, permisos y autenticación
 */
export const useAuthStore = create<any>()(
  devtools(
    persist(
      set => ({
        // Estado inicial
        user: initialUser,
        //permissions: null,
        isAuthenticated: false,
        isLoading: true,
        reasonCancellation: null,

        topes:{
          mensaje_conjunto: null
        },

        // Setters
        setUser: user => set({ user }),

        // Reinicia el user al estado inicial. Se usa en dos casos:
        //  1) useAuth detecta que el ccedasegurado del SSO difiere del persistido
        //     (sesión nueva en el mismo navegador con datos viejos en localStorage).
        //  2) El usuario aterriza en una página terminal (expiredlink,
        //     sessionfinished, vitalsignslimit): se limpia para no arrastrar datos
        //     a una próxima sesión.
        resetUser: () => set({ user: initialUser }),

        setAuthenticated: isAuthenticated => set({ isAuthenticated: isAuthenticated }),
        setLoading: isLoading => set({ isLoading }),
        setReasonCancellation: reasonCancellation => set({ reasonCancellation }),

        setTopes: (topes) => set({ topes }),

        // Logout
        logout: () => {
          // Limpiar localStorage
          localStorage.removeItem(STORAGE_KEYS.ACCESS_TOKEN);
          localStorage.removeItem(STORAGE_KEYS.REFRESH_TOKEN);

          // Resetear estado. user vuelve a initialUser (no null) para que cualquier
          // acceso a user.cpais entre logout y navegación no explote.
          set({
            user: initialUser,
            isAuthenticated: false,
            isLoading: false,
            reasonCancellation: null
          });
        },
      }),
      {
        name: 'auth-storage',
        partialize: state => ({
          // Se persiste user para sobrevivir reloads dentro del mismo flujo
          // (vitalsintroduction, form, vitalsscaning, vitalsresults). useAuth
          // hace merge inteligente: si el ccedasegurado del SSO coincide con el
          // persistido, conserva profile/results/nlocalizaCreated; si difiere,
          // llama resetUser() antes de poblar con la sesión nueva.
          user: state.user,
          //permissions: state.permissions,
          isAuthenticated: state.isAuthenticated,
          reasonCancellation: state.reasonCancellation
        }),
      }
    ),
    { name: 'AuthStore' }
  )
);
